import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { collection, getDocs, query, orderBy } from 'firebase/firestore'
import { httpsCallable } from 'firebase/functions'
import { db, functions } from '@/lib/firebase'
import type { HostingSite } from '@/lib/types'

export function useHostingSites() {
  return useQuery({
    queryKey: ['hosting_sites'],
    queryFn: async (): Promise<HostingSite[]> => {
      const q = query(collection(db, 'hosting_sites'), orderBy('entity'))
      const snap = await getDocs(q)
      return snap.docs.map((d) => ({ ...(d.data() as HostingSite), id: d.id }))
    },
  })
}

export function useRefreshHostingSites() {
  const qc = useQueryClient()
  const fn = httpsCallable<unknown, { ok: boolean; count: number }>(functions, 'refreshHostingSites')
  return useMutation({
    mutationFn: async () => (await fn()).data,
    onSuccess: () => qc.invalidateQueries({ queryKey: ['hosting_sites'] }),
  })
}
